"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MovementReason = void 0;
var MovementReason;
(function (MovementReason) {
    MovementReason["ADJUSTMENT"] = "ADJUSTMENT";
    MovementReason["ASN_RECEIVE"] = "ASN_RECEIVE";
    MovementReason["DAMAGE"] = "DAMAGE";
    MovementReason["RETURN"] = "RETURN";
    MovementReason["TRANSFER"] = "TRANSFER";
    MovementReason["SIMULATED_MOVEMENT"] = "SIMULATED_MOVEMENT";
    MovementReason["COUNT"] = "COUNT";
    MovementReason["FIXUP"] = "FIXUP";
    MovementReason["QUARANTINE"] = "QUARANTINE";
    MovementReason["RELOCATE"] = "RELOCATE";
    MovementReason["SHIPPED"] = "SHIPPED";
})(MovementReason = exports.MovementReason || (exports.MovementReason = {}));
//# sourceMappingURL=ProcessedInventoryMovement.js.map